var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00838 5.29708C0.95164 5.20723 0.923268 5.1623 0.907385 5.09301C0.895455 5.04096 0.895455 4.95888 0.907385 4.90683C0.923268 4.83754 0.95164 4.79261 1.00838 4.70276C1.4773 3.96027 2.87308 2.08325 5.00017 2.08325C7.12725 2.08325 8.52303 3.96027 8.99195 4.70276C9.0487 4.79261 9.07707 4.83754 9.09295 4.90683C9.10488 4.95888 9.10488 5.04096 9.09295 5.09301C9.07707 5.1623 9.0487 5.20723 8.99195 5.29708C8.52303 6.03957 7.12725 7.91659 5.00017 7.91659C2.87308 7.91659 1.4773 6.03957 1.00838 5.29708Z",
    stroke: "#E39D02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00017 6.24992C5.69052 6.24992 6.25017 5.69027 6.25017 4.99992C6.25017 4.30956 5.69052 3.74992 5.00017 3.74992C4.30981 3.74992 3.75017 4.30956 3.75017 4.99992C3.75017 5.69027 4.30981 6.24992 5.00017 6.24992Z",
    stroke: "#E39D02",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f9d686b397f4af6356fd7f4afc0c82d9.svg";
export { ForwardRef as ReactComponent };